import Header4 from "../../Header/Header4";
import {connect} from "react-redux";
import React, {Component} from "react";
import './index.css'
import {Button} from "antd";

class SatelliteReport extends Component {
    state = {}

    renderSimulationDataItem = () => {
        const {SimulationData, meetOrder, simNum} = this.state
        // console.log('具体数据',SimulationData[meetOrder]['空基十二五光学卫星数据仿真sim1']);
        return Array.from({length: 10}).map((value, index) => {
            return (
                <div className="baotou_data_Item baotou_data_Item_hoverable" key={index}>
                    <div className="baotou_item_title">
                        <div className="baotou_item_title_icon"></div>
                        {/*{value.satelite}*/}

                    </div>
                    <hr className="hr_line"/>
                    <div className="baotou_item_body">
                        {/*{value.data.map((value) => {*/}
                        {/*    return (*/}
                        {/*        // <Tooltip title="点击下载" key={value.id}>*/}
                        {/*        <div key={value.id} className="camera_data_item">*/}
                        {/*            <img className="sim_image" src={value.imageUrl} alt=""/>*/}
                        {/*            <div className="camera_download_box">*/}
                        {/*                <div className="camera_text">{value.cameraBand}</div>*/}
                        {/*                <Button*/}
                        {/*                    onClick={() => this._downloadClicked(value.downloadUrl)}*/}
                        {/*                    type="primary" size="small">点击下载*/}
                        {/*                </Button>*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*        // </Tooltip>*/}
                        {/*    )*/}
                        {/*})}*/}
                    </div>
                </div>
            )
        })
    }

    render() {
        return (
            <div className="report_page">
                <Header4/>
                <div className="report_main">
                    <div className="report_item_box">
                        {this.renderSimulationDataItem()}
                    </div>
                </div>
            </div>
        )
    }
}

const mapState = (state) => ({
    loginObj: state.userReducer.get("loginObj").toJS(),
    user: state.userReducer.get("user").toJS(),
});
const mapDispatch = (dispatch) => ({});

export default connect(mapState, mapDispatch)(SatelliteReport);